import { IsNotEmpty, IsNumber } from 'class-validator';

export class NomenclatureTypeFieldRestoreRequest {
    @IsNumber()
    @IsNotEmpty()
    public id: number;

    constructor(data?: Partial<NomenclatureTypeFieldRestoreRequest>) {
        this.id = data?.id;
    }
}
